import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { CaseStudies } from './pages/CaseStudies';
import { CaseStudyDetail } from './pages/CaseStudyDetail';
import { Omnicredit } from './pages/case-studies/Omnicredit';
import { ChristmasPalace } from './pages/case-studies/ChristmasPalace';
import { LevelupInsurance } from './pages/case-studies/LevelupInsurance';
import { ZRoofing } from './pages/case-studies/ZRoofing';
import { ChristmasPalace2 } from './pages/case-studies/ChristmasPalace2';
import { XclusiveAgentLeads } from './pages/case-studies/XclusiveAgentLeads';
import { WatchMeGrow } from './pages/case-studies/WatchMeGrow';
import { Contact } from './pages/Contact';
import { Careers } from './pages/Careers';
export function App() {
  useEffect(() => {
    document.title = 'Engage Media';
  }, []);
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="services" element={<Services data-id="element-7" />} data-id="element-6" />
          <Route path="case-studies" element={<CaseStudies data-id="element-9" />} data-id="element-8" />
          <Route path="case-studies/omnicredit" element={<Omnicredit data-id="element-11" />} data-id="element-10" />
          <Route path="case-studies/christmas-palace" element={<ChristmasPalace data-id="element-13" />} data-id="element-12" />
          <Route path="case-studies/levelup-insurance" element={<LevelupInsurance data-id="element-15" />} data-id="element-14" />
          <Route path="case-studies/z-roofing" element={<ZRoofing data-id="element-17" />} data-id="element-16" />
          <Route path="case-studies/the-christmas-palace-2" element={<ChristmasPalace2 data-id="element-19" />} data-id="element-18" />
          <Route path="case-studies/the-christmas-palace-3" element={<XclusiveAgentLeads data-id="element-21" />} data-id="element-20" />
          <Route path="case-studies/watch-me-grow" element={<WatchMeGrow data-id="element-23" />} data-id="element-22" />
          <Route path="case-studies/:slug" element={<CaseStudyDetail data-id="element-25" />} data-id="element-24" />
          <Route path="contact" element={<Contact data-id="element-27" />} data-id="element-26" />
          <Route path="careers" element={<Careers data-id="element-29" />} data-id="element-28" />
        </Route>
      </Routes>
    </Router>;
}